import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {

  @Input() size: string = 'sm';
  @Input() disabled: boolean = false;
  @Input() btype: string = 'button';
  @Input() color: string;

  // Theme color shortcuts not working yet
  @Input() primary: boolean = false;
  @Input() secondary: boolean = false;
  @Input() success: boolean = false;
  @Input() danger: boolean = false;
  @Input() warning: boolean = false;
  @Input() info: boolean = false;
  @Input() light: boolean = false;
  @Input() dark: boolean = false;
  @Input() link: boolean = false;

  @Output() click: EventEmitter<any> = new EventEmitter();

  constructor() {
    if (this.color == undefined) {
      if (this.primary)        { this.color = 'primary'; }
      else if (this.secondary) { this.color = 'secondary'; }
      else if (this.success)   { this.color = 'success'; }
      else if (this.danger)    { this.color = 'danger'; }
      else if (this.warning)   { this.color = 'warning'; }
      else if (this.info)      { this.color = 'info'; }
      else if (this.light)     { this.color = 'light'; }
      else if (this.dark)      { this.color = 'dark'; }
      else if (this.link)      { this.color = 'link'; }
      else                     { this.color = 'default'; } // Default color
    }
  }

  ngOnInit(): void {
  }

  onClick(event: any) {
    event.stopPropagation();
    if (!this.disabled) {
      this.click.emit();
    }
  }

}
